/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowBadgeLeft = createReactComponent("arrow-badge-left", "IconArrowBadgeLeft", [
  ["path", { d: "M11 17h6l-4 -5l4 -5h-6l-4 5z", key: "svg-0" }]
]);

export { IconArrowBadgeLeft as default };
//# sourceMappingURL=IconArrowBadgeLeft.js.map
